import createPersistedState from "./createPersistedState";
import { useHydrated } from "./useHydrated";
import useTenant from "./useTenant";

const useEnvState = createPersistedState<string>("environment_name");

const useEnv = () => {
  const { tenant } = useTenant();
  const environments = tenant?.environments;
  const [selectedEnvName, setSelectedEnvName] = useEnvState("");
  const hydrated = useHydrated();
  // Don't resolve until we've passed first render; otherwise the persisted
  // env name is still "" and we'd fall back to environments[0] before the
  // stored selection is applied.
  if (!environments || !environments.length || !hydrated) {
    return {
      selectedEnv: null,
      setSelectedEnvName,
    };
  }
  let selectedEnv = environments.filter((environment) => {
    return environment.name === selectedEnvName;
  })[0];

  // For a production tenant, prefer the canonical "production" env over
  // whatever happens to be first in the list. Matters when `useTenant`
  // implicitly resolves to a solo production tenant: no env name is stored,
  // and we want to land in production rather than an arbitrary sibling env.
  if (!selectedEnv && tenant?.kind === "production") {
    selectedEnv = environments.filter((e) => e.name === "production")[0];
  }

  if (!selectedEnv) selectedEnv = environments[0];

  return {
    selectedEnv,
    setSelectedEnvName,
  };
};

export const useToken = () => {
  const { selectedEnv } = useEnv();
  return selectedEnv?.token;
};

export default useEnv;
